import { u, styled } from '../../../../shared/theming-sc'
import PrimaryButton from '../../../primary-button/PrimaryButton'


const ExportWrapper = styled.div`
    margin-bottom: ${u.getSpacing('large')}px;
`

const IconHeader = styled.div`
    display: inline-block;
    margin-top: - ${u.getSpacing('large')}px;

    svg {
        width: ${u.getSpacing('large')}px;
        height: ${u.getSpacing('large')}px;
        path {
            stroke: ${u.getColor('primary')};

        }

    }
`

const Helper = styled.p`
    font-size: 15px !important;
    font-weight: regular !important;
`

const ExportOptions = styled.div`
    margin-top: ${u.getSpacing('small')}px;
`

const ExportButton = styled(PrimaryButton)`
    margin: ${u.getSpacing('small')}px;
`

const ExportLink = styled.a`
    cursor: pointer;
    font-size: ${u.getFontSize('md')};
    color: ${u.getColor('greyDark')};
    text-decoration: underline;
    font-weight: 500;
    display: block;
`

export {
  Helper,
  IconHeader,
  ExportWrapper,
  ExportOptions,
  ExportButton,
  ExportLink
}
